import { render, staticRenderFns } from "./form-article-create.vue?vue&type=template&id=19f05be1"
import script from "./form-article-create.vue?vue&type=script&lang=js"
export * from "./form-article-create.vue?vue&type=script&lang=js"
import style0 from "./form-article-create.vue?vue&type=style&index=0&id=19f05be1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports